import { closePowerStepModal, openPowerStep } from './usePowerStepState';
import { hideQuickAddToBasketModal, setQuickAddToBasketModalId } from './useQuickAddToBasketState';

export async function openPowerStepModal(itemNo: string, warehouseId?: number) {
    await hideQuickAddToBasketModal();
    openPowerStep(itemNo, warehouseId);
}

export async function showQuickAddToBasketModal(sku: string, closePowerStep?: boolean) {
    if (closePowerStep) {
        await closePowerStepModal();
    }
    setQuickAddToBasketModalId(sku);
}
